import React, { Component } from "react";

import "./About.scss";
import FotoProfile from "../../../assets/images/profile.jpg";

class NavBar extends Component {
	render() {
		return (
			<div id="about" className="about col-12 col-sm-10 col-md-8 col-lg-6">
				<div className="content">
					<div className="card">
						<div className="firstinfo">
							<img src={FotoProfile} alt="Profile" />
							<div className="profileinfo">
								<h1>Lopez Damian</h1>
								<h3>Software Developer</h3>
							</div>
						</div>
					</div>
					<div className="bio">
						<p>I am a technology enthusiast, one of my passions is frontend development.</p>
						<p>I am all of focused on my professional development because I love writing code and learning new things.</p>
						<p>So I believe that we can create quality technology from Latin America.</p>
						<p>👨‍💻⌨️</p>
					</div>
				</div>
			</div>
		);
	}
}

export default NavBar;
